import apiClient from '../client';
import { ApiResponse, StageCompleter } from '@/types';

export const resultsApi = {
  getStageCompleters: async (stage: 1 | 2, term?: number): Promise<StageCompleter[]> => {
    const response = await apiClient.get<ApiResponse<StageCompleter[]>>(
      '/results/stage-completers',
      { params: { stage, ...(term !== undefined ? { term } : {}) } },
    );
    return response.data.data ?? [];
  },

  getCombinedStage1: async (): Promise<StageCompleter[]> => {
    const response = await apiClient.get<ApiResponse<StageCompleter[]>>(
      '/results/combined-stage1',
    );
    return response.data.data ?? [];
  },

  disqualifySession: async (sessionId: string, disqualified: boolean): Promise<void> => {
    await apiClient.patch(`/results/sessions/${sessionId}/disqualify`, { disqualified });
  },

  exportWrongAnswersCsv: async (stage?: number, term?: number): Promise<Blob> => {
    const params: Record<string, string> = {};
    if (stage !== undefined) params.stage = stage.toString();
    if (term !== undefined) params.term = term.toString();
    const response = await apiClient.get('/results/export-wrong-answers', {
      params,
      responseType: 'blob',
    });
    return response.data;
  },

  exportAllAnswersCsv: async (stage?: number, term?: number): Promise<Blob> => {
    const params: Record<string, string> = {};
    if (stage !== undefined) params.stage = stage.toString();
    if (term !== undefined) params.term = term.toString();
    const response = await apiClient.get('/results/export-all-answers', {
      params,
      responseType: 'blob',
    });
    return response.data;
  },

  exportStageCsv: async (stage: 1 | 2, term?: number): Promise<Blob> => {
    const response = await apiClient.get('/results/stage-export', {
      params: { stage, ...(term !== undefined ? { term } : {}) },
      responseType: 'blob',
    });
    return response.data;
  },

  /** Combined Etap 1 ranking from both terms, sorted best → worst. */
  exportCombinedStage1Csv: async (): Promise<Blob> => {
    const response = await apiClient.get('/results/stage-export', {
      params: { stage: 1 },
      responseType: 'blob',
    });
    return response.data;
  },

  exportPracticalScoresCsv: async (): Promise<Blob> => {
    const response = await apiClient.get('/results/export-practical-scores', {
      responseType: 'blob',
    });
    return response.data;
  },

  exportStage2FullCsv: async (): Promise<Blob> => {
    const response = await apiClient.get('/results/export-stage2-full', {
      responseType: 'blob',
    });
    return response.data;
  },
};
